import { ImageListItem } from "@mui/material"

export function RegimeImage({ item }) {
    return (
        <ImageListItem sx={{ overflow: "hidden" }}>
            <img src={item} alt="Facility" loading="lazy" style={{ objectFit: "cover", height: "100%" }} />
        </ImageListItem>
    )
}
